import React from 'react';
import PropertyManager from '@synergycms_core/components/HoC/propertyManager';
import { compose, is } from 'ramda';

import CheckboxField from '@synergycms_core/components/generic/Form/CheckboxField.jsx';

import { RichText } from '@synergycms_core/components/generic/';
import actions from '../../../../store/actions';
import connect from 'react-redux/lib/connect/connect';
import { validateAsyncComponent } from '../../../HoC';
import { Map } from 'immutable';
import { Button } from 'synergycms_core/src/components/generic';
import ModalOnUnSelectCheck from '../ModalOnUnSelectRate';
import ConditionsModal from '../../CustomerForm/ConditionsModal';
import InputNotify from '@synergycms_core/components/generic/Form/InputNotify';


//const iscorporate = store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1'

const FidelTourPoliciesChecks = class StandarPoliciesChecks extends React.Component {
  static displayName = 'FidelTourPoliciesChecks';

  constructor(props) {
    super(props);
    this.state = {
      visible:false
    }
  }


  visibleGDPR = (e) => {
    this.setState((state)=>{
      return {
        visible:true
      };
    });
  };

  closeModalCallback = (value) => {
    if(!value) this.props.config.setSignInLoyalty(value);
    window.document.body.scrollTop = window.document.documentElement.scrollTop = 0;
  }


  render() {
    const { config } = this.props;
    const { classes, hotel, isCorporate, reservation } = config;

    return (!isCorporate && <>

      <label className={classes.checkBox}  ref={'check_loyalty'}>
        <CheckboxField
          defaultValue={reservation.getIn(['customer', 'check_loyalty'], false)}
          type={'checkbox'}
          validations={["required"]}
          validationsFields={{ field: '' }}
          model={'check_loyalty'}
          innerStyle={['inputCheck', classes.inputCheck]}
          css={{ invalid: null, valid: null }}
        />

        {/*<PolicyModalGroup group={group} penalties={penalties} requiredPrepaymentText={requiredPrepaymentText}/>*/}

        <React.Fragment>
          <RichText
            translate={true}
            ucFirst={true}
            innerStyle={['check_loyalty']}
            text={'_%deseo formar parte del programa de fidelidad MEMBERS ONLY del%_'}
          />{' '}
          <RichText
            innerStyle={['check_loyalty']}
            text={hotel.get('name')}
          />{', '}
          <RichText
            translate={true}
            innerStyle={['check_loyalty']}
            text={'_%de conformidad con lo dispoesto en los%_'}
          />{' '}
          <label ref={''}>
            <ConditionsModal modalTitle={'_%términos y Condiciones del programa%_'} modalText={'_%loyalty_terms%_'}
                             ucFirst={true} isStarTraveler={true} />{'. '}
          </label>
          <RichText
            translate={true}
            ucFirst={true}
            text={'_%si no quieres recibir información comercial, haz click%_'}
          />{' '}
          <Button
            onClick={this.visibleGDPR}
            richText={{ translate: true, text: '_%aquí%_' }}
            innerStyle={[classes.refuseInfoBtn]}
          />{'. '}
          <RichText
            translate={true}
            ucFirst={true}
            text={'_%si no deseas formar parte del programa, haz clic%_'}
          />{' '}
          <ModalOnUnSelectCheck closeCallback={this.closeModalCallback}>
            {(toggleModal) => {
              return (<Button
                onClick={toggleModal}
                richText={{ translate: true, text: '_%aquí%_' }}
                innerStyle={[classes.refuseInfoBtn]}
              />);
            }}
          </ModalOnUnSelectCheck>
        </React.Fragment>

        <InputNotify model={'check_loyalty'} css={{ valid: null }}/>

      </label>

      {(this.state.visible || reservation.getIn(['customer', 'GDPR_loyalty'])) && <label className={classes.checkBox}>
        <CheckboxField
          defaultValue={reservation.getIn(['customer', 'GDPR_loyalty'], false)}
          type={'checkbox'}
          model={'GDPR_loyalty'}
          innerStyle={['inputCheck', classes.inputCheck]}
        />
        <RichText translate={true} ucFirst={true} innerStyle={['GDPR_loyalty']} text={'_%Prefiero no recibir futuras comunicaciones vinculadas a promociones especiales y ofertas exclusivas vinculadas al programa de fidelización.%_'} />
      </label>}
     </>);
  };

};


const mapDispatchToProps = (dispatch, ownProps, state) => {
  return {
    setSignInLoyalty: (value) => {
      //dispatch(customerActions.reservation.set(reservation.setIn(['customer', 'check_loyalty'], value)));
      return Promise.all([
        dispatch(actions.customer.availTypeSelected.set("standard")),
        dispatch(actions.customer.reservationRequest.set(Map({loyalty : false})))
      ]).then(() => {
        dispatch(actions.customer.loyalty.refreshReservation());
      });
    },
  };
};

const mapStateToProps = (store, ownProps) => {
  const reservation = store.getIn(['customer', 'reservation']);
  const hotelId = store.getIn(['customer', 'current_hotel']);
  let hotelInfo = store.getIn(['hotels', hotelId]);
  hotelInfo = is(Map, hotelInfo) && hotelInfo.size > 0 && hotelInfo.get('name') && hotelInfo;
  const loyaltyType = store.getIn(["customer", "loyalty", "data", "loyalty", "code"], null);

  const isNotFinallyConfirmed = !(
    reservation.get('status', false) === 'confirmed' &&
    !(
      (['op', 'amazon_pay'].includes(reservation.getIn(['payment', 'payform_code'], false))) &&
      reservation.getIn(['payment', 'state'], false) === 'pending'
    )
  );

  const roomRatesSelected = store.getIn(['customer', 'reservation_request']);
  const loyaltyRoomsAvail = store.getIn([
    'avail',
    hotelId,
    store.getIn(['hotels', hotelId, 'params', 'loyalty_query_params']),
    'response'
  ],false);

  return {
    hotel: hotelInfo,
    loyaltyUser: store.getIn(['customer', 'loyalty','user',"user_id"], null) && store.getIn(['customer', 'loyalty','user'], null),
    loyaltySelected: !!loyaltyRoomsAvail && roomRatesSelected.get('loyalty', false),
    loyaltyType: loyaltyType,
    isCorporate : store.getIn(['customer', 'corporate', 'tipo_perfil'], false) === '1',
    reservation: reservation.size > 0 && isNotFinallyConfirmed ? reservation : undefined,
    check_loyalty: reservation.getIn(['customer', 'check_loyalty'], true),
  };
};


export default compose(
  validateAsyncComponent(mapStateToProps),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  //withThemeJSS(),
  PropertyManager([
    "classes",
    "hotel",
    "loyaltyUser",
    "loyaltySelected",
    "loyaltyType",
    "isCorporate",
    "reservation",
    "setSignInLoyalty",
  ])
)(FidelTourPoliciesChecks);



